import React from 'react';

const DarkBackground = ({ children }) => {
     return (
          <div className='dark-bg'>{ children }</div>
     )
};

export default DarkBackground;